import { useLayoutStore } from "./pinia/layout";
import { useNotificationStore } from "./pinia/notification";
import { useAyedoStore } from "./pinia/ayedo";

import { createPinia } from "pinia";

const pinia = createPinia();
export default pinia;

export { useLayoutStore, useNotificationStore, useAyedoStore };
